import React from "react";
import "./table.css";
import data from "./data.json";

export default function Table({ selectedData }) {
  const rows = data.filter((item) => selectedData.indexOf(item.label) > -1);
  return (
    <div>
      <table className="table table-bordered">
        <thead className="table-thead">
          <tr className="TableCenter">
            <th scope="col"><spam data-toggle="tooltip" data-placement="top" title="توضیح در رابطه با این فیلد مقایسه">Spec.</spam></th>
            <th scope="col" className="Spec">HTHS(cP) SA(%)</th>
            <th scope="col" >SA (%)</th>
            <th scope="col">p (%)</th>
            <th scope="col">S (%)</th>
            <th scope="col">Min T</th>
        

          </tr>
        </thead>
        
        <tbody>
          {rows.map((row) => (
            <tr key={row.label}>
              <th scope="row">{row.label}</th>
              <td>{row.HTHS}</td>
              <td>{row.SA}</td>
              <td>{row.p}</td>
              <td>{row.S}</td>
              <td>{row.Min}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
